import React, { useContext } from "react"
import { observer } from "mobx-react"
import { ActionIcon, CopyButton, Tooltip } from "@mantine/core"
import { IconCheck, IconLink } from "@tabler/icons-react"
import { AppWorkspaceContext } from "../stores/AppWorkspace"

type CopyAnchorButtonProps = {
  anchor: string
  path?: string
  label?: string
}

export const CopyAnchorButton: React.FC<CopyAnchorButtonProps> = observer(
  ({ anchor, path, label = "Copy link" }) => {
    const workspace = useContext(AppWorkspaceContext)
    const hash = anchor.replace(/^#/, "")
    const basePath = path ?? window.location.pathname
    const href = hash ? `${basePath}#${hash}` : basePath
    const value = workspace.absoluteUrl(href)

    return (
      <CopyButton value={value} timeout={1600}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? "Copied" : label} withArrow>
            <ActionIcon
              variant="subtle"
              color={copied ? "orGreen" : "gray"}
              size="sm"
              onClick={(event) => {
                event.preventDefault()
                event.stopPropagation()
                copy()
              }}
              aria-label={copied ? "Copied link" : "Copy link to this section"}
            >
              {copied ? <IconCheck size={16} /> : <IconLink size={16} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    )
  }
)
